<template>
  <div class="max-w-[425px] bg-white border-x-gray-[#E6E6E6] border-x h-screen mx-auto px-[20px] lg:px-[40px] md:px-[40px] flex flex-col justify-center">
    <div class="flex lg:pt-[10px] md:pt-[10px] justify-center items-center ">
      <first-step/>
    </div>
    <div class="text-center mt-[8px] ">
      <h1 class="text-[20px] mb-[16px]">تو همیشه زیبایی، با هر اندامی!</h1>
      <p class="text-[#909090] text-[16px] tracking-tight">و در تلاشی برای سالم ماندن و خوش اندام تر شدن.</p>
    </div>
    <div class="lg:pt-48 pb-5 pt-[100px] show-for-small">
      <div class="text-center mb-[24px]">
        <p class="text-[14px] text-[#555555]">لطفا 3 دقیقه وقت بزار تا روش لاغر شدنت رو بهت بگم.</p>
      </div>
        <button @click="redirect" class="blob rounded-lg w-full flex justify-center items-center text-white bg-green-3000 text-[14px] font-[600] mb-4">می خوام همین الان شروع کنم</button>
    </div>
  </div>
</template>

<script>

import FirstStep from "@/components/Icons/1stStep";
export default {
  name: 'MainView',
  components: {
    FirstStep

  },
  methods:{
    redirect(){
      this.$router.push({name: 'home', path: '/home'})
    }
  }
}
</script>

<style scoped>
@media screen and (max-height: 640px) {
  .show-for-small{
    padding-top: 10px !important;
  }
}
.blob {
  box-shadow: 0 0 0 0 rgb(16 172 132 / 50%);
  transform: scale(1);
  animation: pulse-black 2s infinite;
  border: 1px solid transparent;
  padding: 12px 10px;
}

@keyframes pulse-black {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgb(16 172 132 / 50%);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}
</style>
